import { useEffect, useRef, useState } from 'react';

import { EventSource } from 'lib/eventSource';
import { MERCURE_API } from 'lib/utilities';
import { action } from 'lib/actionHelpers';
import { getMercureToken } from 'redux/actions/userActions.js';
import { useSelector } from 'react-redux';

const useEvent = (service_provider_id) => {
  const eventRef = useRef({});
  const { mercurePubSubToken } = useSelector((state) => state.user);
  const [fetchMercureToken, setFetchMercureToken] = useState(() => true);
  const currentServiceProviderId = useRef(true);

  useEffect(() => {
    // Initialize hook with token fetch
    currentServiceProviderId.current = service_provider_id;
    if (service_provider_id && fetchMercureToken === true) {
      if (eventRef.current && eventRef.current.close) {
        eventRef.current.close();
        action('DELETE_MERCURE_TOKEN');
      }
      getMercureToken(() => {
        setFetchMercureToken(false);
      });
    }
  }, [service_provider_id, fetchMercureToken]);

  useEffect(() => {
    if (service_provider_id && eventRef.current) {
      setFetchMercureToken(true);
    }
  }, [service_provider_id]);

  useEffect(() => {
    if (mercurePubSubToken && service_provider_id && setFetchMercureToken !== undefined) {
      eventRef.current = new EventSource(`${MERCURE_API}_${currentServiceProviderId.current}`, {
        headers: {
          Authorization: 'Bearer ' + mercurePubSubToken,
        },
      });
    }
  }, [mercurePubSubToken]);

  return { events: eventRef.current, setFetchMercureToken };
};

export { useEvent };
